import { FC } from "react";
import { BsInfoCircle } from "react-icons/bs";
import Panel from "./Panel";

const DescriptionPanel: FC = () => {
  return (
    <Panel
      initiallyDeployed
      title={
        <>
          <BsInfoCircle className="text-muted" /> Description
        </>
      }
    >
      <p>
        Drag the graph, so you can read this clearly, if needed. Also search for Leetcode problem title or node labels. This visualization represents a network of LeetCode problems. Each node represents a problem, and the edges between nodes indicate related problems.
      </p>
      <p>
        The size of each node is proportional to its score, which is calculated based on the number of companies that asked the problem. The color of each node represents its topic cluster.
      </p>
      <p>
        Feel free iterate over the network by selecting one topic at a time. You can also filter the network by company clusters after you choose the topics. The network will show only the problems that belong to the selected topic and company clusters.
      </p>
      <p>
        Hovering on a node, shows all related problem connection in the knowledge graph. Clicking on a node will show the problem description and the related problems with descriptions.
      </p>
    </Panel>
  );
};

export default DescriptionPanel;
